if (!customElements.get('br-rug-gallery-filter')) {
  customElements.define('br-rug-gallery-filter', class extends HTMLElement {
    connectedCallback() {
      this.gallery = document.getElementById(this.dataset.galleryId);
      if (!this.gallery) return;
      this.productInfo = this.gallery.closest('product-info');
      this.onVariant = (event) => {
        const data = event.detail || event.data;
        if (data?.sectionId === this.gallery.dataset.section && data.variant) {
          this.queueDesign(data.variant.option1);
        }
      };
      this.onClick = (event) => {
        if (!event.target.closest('variant-selects')) return;
        const label = event.target.closest('label');
        const input = label ? document.getElementById(label.htmlFor) : event.target;
        if (input?.matches('input[type="radio"]')) this.queueDesign(input.value);
      };
      document.addEventListener('variant:change', this.onVariant);
      this.productInfo?.addEventListener('click', this.onClick);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant);
      }
      const modal = document.getElementById(`ProductModal-${this.gallery.dataset.section}`);
      if (modal) modal.dataset.brRugModal = 'true';
      const input = this.productInfo?.querySelector('variant-selects input[type="radio"]:checked');
      this.queueDesign(input?.value || this.gallery.dataset.brInitialDesign, true);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariant);
      this.productInfo?.removeEventListener('click', this.onClick);
      this.unsubscribe?.();
      cancelAnimationFrame(this.frame);
    }

    queueDesign(value, initializing = false) {
      const rawKey = value?.toLowerCase().replace(/\s+/g, '');
      const key = ({ rosa: 'rosado', blue: 'celeste' })[rawKey] || rawKey;
      if (!['arcoiris', 'cohetes', 'rosado', 'verde', 'celeste'].includes(key)) return;
      this.design = key;
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.applyDesign(initializing));
    }

    groupFor(element) {
      const image = element.matches('img') ? element : element.querySelector('img');
      const source = image?.getAttribute('src') || '';
      const alt = (element.dataset.alt || image?.alt || '').toLowerCase();
      if (source.includes('-arcoiris-') || alt.includes('— arcoiris —')) return 'arcoiris';
      if (source.includes('-cohetes-') || alt.includes('— cohetes —')) return 'cohetes';
      if (source.includes('rosado-') || alt.includes('— rosado —')) return 'rosado';
      if (source.includes('verde-') || alt.includes('— verde —')) return 'verde';
      if (source.includes('celeste-') || alt.includes('— celeste —')) return 'celeste';
      return '';
    }

    setVisibility(element, show) {
      element.classList.toggle('hidden', !show);
      element.toggleAttribute('data-br-rug-hidden', !show);
      if (show) element.removeAttribute('aria-hidden');
      else element.setAttribute('aria-hidden', 'true');
    }

    applyDesign(initializing = false) {
      const slides = Array.from(this.gallery.querySelectorAll('.product__media-item[data-media-id]'));
      const visible = slides.filter((slide) => this.groupFor(slide) === this.design);
      if (visible.length !== (['rosado', 'verde', 'celeste'].includes(this.design) ? 4 : 6)) return;
      slides.forEach((slide) => this.setVisibility(slide, visible.includes(slide)));
      const groups = new Map(slides.map((slide) => [slide.dataset.mediaId, this.groupFor(slide)]));
      this.gallery.querySelectorAll('.thumbnail-list__item, .dot-navigation-dot, .slider-counter__link[data-target]').forEach((element) => {
        const group = this.groupFor(element) || groups.get(element.dataset.target);
        this.setVisibility(element, group === this.design);
      });
      const modal = document.getElementById(`ProductModal-${this.gallery.dataset.section}`);
      if (modal) {
        modal.dataset.brRugModal = 'true';
        modal.querySelectorAll('.product-media-modal__content [data-media-id]').forEach((element) => {
          this.setVisibility(element, this.groupFor(element) === this.design);
        });
      }
      this.gallery.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
      const active = this.gallery.querySelector('.product__media-item.is-active');
      if (!initializing || active !== visible[0]) {
        this.gallery.setActiveMedia?.(visible[0].dataset.mediaId, false);
      }
      this.gallery.querySelectorAll('.slider-counter--total').forEach((counter) => { counter.textContent = String(visible.length); });
      this.gallery.dataset.brSelectedDesign = this.design;
    }
  });
}

